module.exports = __webpack_public_path__ + "dimsans-webfont.69a52dc190fd2e8c0d52.woff";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/dimsans-webfont.woff
// module id = ../../../../../src/assets/fonts/dimsans-webfont.woff
// module chunks = styles